import * as React from 'react';

import HandshakeAgreement56 from './HandshakeAgreement56';

export const handshakeAgreement56 = () => <HandshakeAgreement56 />;

export default {
    title: 'Illustration/HandshakeAgreement56',
    component: HandshakeAgreement56,
    parameters: {
        notes: "`import HandshakeAgreement56 from 'box-ui-elements/es/illustration/HandshakeAgreement56';`",
    },
};
